import React from "react";
import ButtonBlack from "@shared/uiNew/Button/button_black";
import { Rich } from "../rich";
import * as styles from "./Hero.module.scss";
import type { RichText } from "@shared/arrays/page-common";

export interface HeroProps {
  /** Written for search; the export's own headline follows as `lead`. */
  title: React.ReactNode;
  lead?: string;
  paragraphs?: RichText[];
  bullets?: string[];
  note?: string[];
  cta: string;
  ctaHref: string;
  image?: string;
  imageAlt?: string;
  children?: React.ReactNode;
}

export function Hero({
  title,
  lead,
  paragraphs,
  bullets,
  note,
  cta,
  ctaHref,
  image,
  imageAlt,
  children,
}: HeroProps) {
  return (
    <section className={styles.hero}>
      <div className={`${styles.inner} ${image || children ? "" : styles.innerSolo}`}>
        <div className={styles.content}>
          <h1 className={styles.title}>{title}</h1>
          {lead && <p className={styles.lead}>{lead}</p>}

          {paragraphs?.map((parts, i) => (
            <p key={i} className={styles.text}>
              <Rich parts={parts} />
            </p>
          ))}

          {bullets && (
            <ul className={styles.bullets}>
              {bullets.map((b) => (
                <li key={b}>{b}</li>
              ))}
            </ul>
          )}

          <div className={styles.actions}>
            <ButtonBlack icon="arrow" text={cta} href={ctaHref} type="link" />
          </div>

          {note && (
            <p className={styles.note}>
              {note.map((line) => (
                <React.Fragment key={line}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </p>
          )}
        </div>

        {(image || children) && (
          <div className={styles.media}>
            {children ?? (
              <img src={image} alt={imageAlt} loading="eager" decoding="async" />
            )}
          </div>
        )}
      </div>
    </section>
  );
}

export default Hero;
